// @flow
import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

import { LoadingProgress } from "imagus-components";

class AccountGroupsTable extends Component<*> {

  render(): * {
    const groups = this.props.groups;
    const groupList = groups && groups.map((group: *, i: number): * => {
      return (
        <TableRow key={i}>
          <TableCell padding="dense">{group}</TableCell>
          <TableCell padding="dense">[Not Completed]</TableCell>
        </TableRow>
      );
    });
    if (groups === undefined) {
      return (
        <div className="app-panel-content panel-top-margin">
          <LoadingProgress />
        </div>
      );
    }
    else {
      return (
        <div className="app-panel-content panel-top-margin">
          {groups.length > 0 &&
            <Grid container spacing={24}>
              <Grid item xs={12} style={{ maxWidth: "520px" }}>
                <h3>Group</h3>
                <Paper>
                  <Table className="app-table">
                    <TableHead>
                      <TableRow>
                        <TableCell className="blue-shine">Name</TableCell>
                        <TableCell className="blue-shine">Description</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {groupList}
                    </TableBody>
                  </Table>
                </Paper>
              </Grid>
            </Grid>
          }
        </div>
      );
    }
  }
}

export default AccountGroupsTable;
